import { IrvingEnv } from '../types';
declare let process: IrvingEnv;

export const ENVIRONMENT = process.env.NODE_ENV;
export const API_URL = process.env.REACT_APP_API_BASE;
export const APP_EMAIL = process.env.REACT_APP_EMAIL;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const REACT_APP_GTM_ID = process.env.REACT_APP_GTM_ID;
export const REACT_APP_GOOGLE_ADS_ID_CRISPIN = process.env.REACT_APP_GOOGLE_ADS_ID_CRISPIN;
export const SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY || '';
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'DEV';
export const REPORT_ERRORS_REMOTELY = process.env.REACT_APP_REPORT_ERRORS_REMOTELY;
export const REPORT_ERRORS_TO_CONSOLE = process.env.REACT_APP_REPORT_ERRORS_TO_CONSOLE;
export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const STREAK_START_DATE = process.env.REACT_APP_STREAK_START_DATE || '2024-03-18';

export const ENDPOINTS_USER = {
  user: `${process.env.REACT_APP_API_BASE}/users`,
  change_email: `${process.env.REACT_APP_API_BASE}/user/email/change`,
  verify_email: `${process.env.REACT_APP_API_BASE}/user/email/verify`,
  reverify_email: `${process.env.REACT_APP_API_BASE}/user/email/reverify`,
  forgot_password: `${process.env.REACT_APP_API_BASE}/user/password/forgot`,
  change_password: `${process.env.REACT_APP_API_BASE}/user/password/change`,
  reset_password: `${process.env.REACT_APP_API_BASE}/user/password/reset`,
  token: `${process.env.REACT_APP_API_BASE}/user/token`,
};

export const ENDPOINTS_AUTH = {
  login: `${process.env.REACT_APP_API_BASE}/authentication`,
  persona: `${process.env.REACT_APP_API_BASE}/authentication/persona`,
  workday: `${process.env.REACT_APP_API_BASE}/authentication/workday`,
  brainLabs: `${process.env.REACT_APP_API_BASE}/authentication/brainlabs`,
};

export const ENDPOINTS_SIMULATIONS = {
  simulations: `${process.env.REACT_APP_API_BASE}/simulations`,
  expression: `${process.env.REACT_APP_API_BASE}/suggest/expression`, // - not used anymore
  fast_expression: `${process.env.REACT_APP_API_BASE}/suggest/fastexpr`, // - list of operators, used in every code editor/viewer components (simulation, learn, alphas)
  language_fields: `${process.env.REACT_APP_API_BASE}/suggest/fields`, // - list of fields used in super alphas
  example: `${process.env.REACT_APP_API_BASE}/suggest/examples`, //  - example alphas with description. Is used in simulation code editor
  new_language_fields: `${process.env.REACT_APP_API_BASE}/data-fields`, //  - list of fields with full info. It's required to call it with instrumentType, delay, region, universe GET parameters. Is used in code editor components (simulation)
  all_language_fields: `${process.env.REACT_APP_API_BASE}/data-fields/summary`, // - list of all fields with ids only. Is used in code viewer components (learn, alphas)
  selection: `${process.env.REACT_APP_API_BASE}/simulations/super-selection`,
};

export const ENDPOINTS_ALPHAS = {
  alpha: `${process.env.REACT_APP_API_BASE}/alphas`,
  tags: `${process.env.REACT_APP_API_BASE}/tags`,
};

export const ENDPOINTS_TEAMS = {
  teams: `${process.env.REACT_APP_API_BASE}/teams`,
};

export const ENDPOINTS_COMPETITIONS = {
  competitions: `${process.env.REACT_APP_API_BASE}/competitions`,
  competitionsLevels: `${process.env.REACT_APP_API_BASE}/competition-levels`,
  consultant: `${process.env.REACT_APP_API_BASE}/consultant`,
};

export const ENDPOINTS_CONTACT = {
  options: `${process.env.REACT_APP_API_BASE}/contact`,
  submit: `${process.env.REACT_APP_API_BASE}/contact`,
  attachment: `${process.env.REACT_APP_API_BASE}/contact/attachment`,
};

export const ENDPOINTS_MESSAGES = {
  messages: `${process.env.REACT_APP_API_BASE}/users`,
  message: `${process.env.REACT_APP_API_BASE}/messages`,
};

export const ENDPOINTS_AGREEMENTS = {
  agreements: `${process.env.REACT_APP_API_BASE}/agreements`,
  accept: process.env.REACT_APP_API_BASE,
};

export const ENDPOINTS_SEARCH = {
  search: `${process.env.REACT_APP_API_BASE}/search`,
};

export const ENDPOINTS_CONSULTANT = {
  boards: `${process.env.REACT_APP_API_BASE}/consultant/boards`,
};

export const ENDPOINTS_REFERENCES = {
  references: `${process.env.REACT_APP_API_BASE}/references`,
};
export const ENDPOINTS_TUTORIALS = {
  tutorials: `${process.env.REACT_APP_API_BASE}/tutorials?limit=50`, // set limit to 50 to show all results, as 10 is default
  tutorialsPages: `${process.env.REACT_APP_API_BASE}/tutorial-pages`,
};
export const ENDPOINTS_VIDEO_COURSES = {
  videoCourses: `${process.env.REACT_APP_API_BASE}/video-courses`,
};
export const ENDPOINTS_EVENTS = {
  events: `${process.env.REACT_APP_API_BASE}/events`,
};
export const ENDPOINTS_CONFIGURATION = {
  configuration: `${process.env.REACT_APP_API_BASE}/configuration`,
};
export const ENDPOINTS_DATA_EXPLORER = {
  datasets: `${process.env.REACT_APP_API_BASE}/data-sets`,
  dataFields: `${process.env.REACT_APP_API_BASE}/data-fields`,
  dataCategories: `${process.env.REACT_APP_API_BASE}/data-categories`,
  dataSearch: `${process.env.REACT_APP_API_BASE}/data-sets/search`,
};

export const ENDPOINT_VERSION = 'version=2.0';

export const ENDPOINTS_OPERATORS = {
  operators: `${process.env.REACT_APP_API_BASE}/operators`,
};

export const ENDPOINTS_ACHIEVEMENTS = {
  achievements: `${process.env.REACT_APP_API_BASE}/achievements`,
};
